import { http } from '../utils';

const fetchBlob = url => http.get(url, { responseType: 'blob' });

export default fetchBlob;
